import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  FacebookIcon,
  TwitterShareButton,
  XIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
} from 'react-share';
import {
  User,
  Mail,
  Phone,
  Calendar,
  MapPin,
  Home,
  CreditCard,
  Lock,
  Loader2,
  Copy,
  Check,
  Send,
  DollarSign,
  Users,
  Share2
} from 'lucide-react';

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [referralLink, setReferralLink] = useState('');
  const [referralCode, setReferralCode] = useState('');
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSendingReferral, setIsSendingReferral] = useState(false);
  const [referralEmail, setReferralEmail] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('All');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [prooffile, setProofFile] = useState(null);
  const [clients, setClients] = useState([]);

  const [attachments, setAttachments] = useState([]);

  const [nameto, setName] = useState(''); 

 

  const [formData, setFormData] = useState({
    propertyBought: "",
    propertyPrice: "",
    noOfUnits: "",
    clientId: "",
  clientName: "",
  clientEmail: "",
  clientPhone: ""
  });

  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authUser") || ""}`,
      'Content-Type': 'multipart/form-data'
    }
  };


  const fetchAndUpdateUserData = async () => {
    try {
      const data = JSON.parse(localStorage.getItem("authUser"));

      console.log("data for refetching users details", data)
      const response = await axios.get(
        `https://portal-sanieldanproperties-api.onrender.com/dashboard/user/${data._id}`,
        config
      );

      console.log(data)
      
      if (response.data) {
        // Update state
        setUser(response.data);
        // Update localStorage
        localStorage.setItem("authUser", JSON.stringify(response.data));
        return true;
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      return false;
    }
  };

  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (!localStorage.getItem("authUser")) {
          navigate('/');
          return;
        }
        
        const data = JSON.parse(localStorage.getItem("authUser"));
        setUser(data);


        // First try to get fresh data
      const freshDataSuccess = await fetchAndUpdateUserData();
      
      // If fresh data fetch fails, fall back to localStorage
      if (!freshDataSuccess) {
        const data = JSON.parse(localStorage.getItem("authUser"));
        setUser(data);
      }
        
        const response = await axios.get(
          `https://portal-sanieldanproperties-api.onrender.com/dashboard/api/get-referral-link/${data.username}`,
          config
        );
        
        if (response.status === 200) {
          setReferralCode(response.data);
          setReferralLink(`https://sanielda.onrender.com/${response.data}/signup`);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        toast.error('Error loading user data');
      }
    };

    fetchUserData();
  }, [navigate]);


  useEffect(() => {
    const handleBeforeUnload = async () => {
      await fetchAndUpdateUserData();
    };
  
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://portal-sanieldanproperties-api.onrender.com/admin/api/products');
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
        toast.error('Error loading products');
      }
    };
    fetchProducts();
  }, []);

  // Fetch transactions
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        if (selectedTransaction) {
          const response = await axios.get(
            `https://portal-sanieldanproperties-api.onrender.com/admin/products-transactions/${selectedTransaction}`
          );
          setTransactions(response.data);
        }
      } catch (error) {
        console.error('Error fetching transactions:', error);
        toast.error('Error loading transactions');
      }
    };
    fetchTransactions();
  }, [selectedTransaction]);

  // Handle file changes
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'giweexpv');
    setProofFile(formData);
  };



// Then add these handler functions
const handleFileChangeattachment = (e) => {
  const files = Array.from(e.target.files);
  setAttachments(prev => [...prev, ...files]);
  e.target.value = ''; // Reset input to allow selecting same file again
};

const removeAttachment = (index) => {
  setAttachments(prev => prev.filter((_, i) => i !== index));
};

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle prospect changes
  const handleProspectChange = (e, fieldName) => {
    const updatedProducts = [...products];
    const updatedProduct = updatedProducts.find(p => p._id === selectedProduct);
    if (updatedProduct) {
      updatedProduct[fieldName] = e.target.value;
      setProducts(updatedProducts);
    }
  };


  // Handle form submissions
  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      let attachmentUrls = [];
    if (attachments.length > 0) {
      for (const file of attachments) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'giweexpv');
        const response = await axios.post(
          'https://api.cloudinary.com/v1_1/dwpoik1jm/image/upload',
          formData
        );
        attachmentUrls.push(response.data.secure_url);
      }
    }

      const selectedProductData = products.find(p => p._id === selectedProduct);
      if (!selectedProductData) {
        throw new Error('Product not found');
      }

      const payload = {
        prospectName: selectedProductData.prospectName,
        prospectEmail: selectedProductData.prospectEmail,
        mobileNumber: selectedProductData.mobileNumber,
        productId: selectedProduct,
        productImage: selectedProductData.productimage,
        productTitle: selectedProductData.producttitle,
        productPrice: selectedProductData.productprice,
        productLocation: selectedProductData.productlocation,
        attachmentUrls,
        user_id: user._id
      };

      const response = await axios.post(
        'https://portal-sanieldanproperties-api.onrender.com/dashboard/sendDetails',
        payload
      );

      toast.success(response.data.message);
      closeProductDetails();
    } catch (error) {
      console.error('Error sending details:', error);
      toast.error(error.message || 'Error sending details');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await axios.get(
          `https://portal-sanieldanproperties-api.onrender.com/dashboard/clients?realtorId=${user._id}`,
          config
        );
        setClients(response.data.clients || []);
      } catch (error) {
        console.error('Error fetching clients:', error);
        toast.error('Error loading clients');
      }
    };
  
    if (user._id) {
      fetchClients();
    }
  }, [user._id]);



  // Handle payment proof upload
  const handleUploadAndSendEmail = async () => {
    setIsLoading(true);
    try {
      let imageUrl;
      if (prooffile) {
        const response = await axios.post(
          'https://api.cloudinary.com/v1_1/dwpoik1jm/image/upload', 
          prooffile
        );
        imageUrl = response.data.secure_url;
      }
  
      const payload = {
        propertyBought: formData.propertyBought,
        propertyPrice: formData.propertyPrice,
        noOfUnits: formData.noOfUnits,
        imageUrl: imageUrl,
        user_id: user._id,
        clientId: formData.clientId,
        clientName: formData.clientName,
        clientEmail: formData.clientEmail,
        clientPhone: formData.clientPhone
      };
  
      const response = await axios.post(
        'https://portal-sanieldanproperties-api.onrender.com/dashboard/sendproof',
        payload
      );
  
      toast.success(response.data.message);
      setShowModal(false);
      setFormData({ 
        propertyBought: "", 
        propertyPrice: "", 
        noOfUnits: "",
        clientId: "",
        clientName: "",
        clientEmail: "",
        clientPhone: ""
      });
    } catch (error) {
      console.error('Error uploading file and sending email:', error);
      toast.error(error.message || 'Error uploading payment proof');
    } finally {
      setIsLoading(false);
    }
  };

  // Handle referral email sending
  const handleSendReferralEmail = async () => {
    if (!referralEmail) {
      toast.error('Please enter an email address');
      return;
    }

    setIsSendingReferral(true);
    try {
      const payload = {
        recipientEmail: referralEmail,
        referralLink: referralLink,
        senderName: `${user.firstName} ${user.lastName}`,
        senderEmail: user.email,
        senderPhone: user.phoneNumber,
        sendname: nameto,
      };

      const response = await axios.post(
        'https://portal-sanieldanproperties-api.onrender.com/dashboard/send-referral-email',
        payload
      );

      toast.success('Referral email sent successfully!');
      setReferralEmail('');
    } catch (error) {
      console.error('Error sending referral email:', error);
      toast.error(error.response?.data?.message || 'Error sending referral email');
    } finally {
      setIsSendingReferral(false);
    }
  };

  // Helper functions
  const showtransaction = (productId) => {
    setSelectedTransaction(productId);
    setModalOpen(true);
  };

  const showProductDetails = (productId) => {
    setSelectedProduct(productId);
  };

  const closeProductDetails = () => {
    setSelectedProduct(null);
  };

  const closetransactions = () => {
    setSelectedTransaction(null);
    setModalOpen(false);
  };

  const downloadProductForm = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(new Blob([blob]));
      const fileName = url.split("/").pop();
      const aTag = document.createElement("a");
      aTag.href = blobUrl;
      aTag.setAttribute("download", fileName);
      document.body.appendChild(aTag);
      aTag.click();
      aTag.remove();
      toast.success('Download started');
    } catch (error) {
      console.error('Error downloading form:', error);
      toast.error('Error downloading form');
    }
  };

  const shareProduct = (product, platform) => {
    try {
      const ogImage = product.productimage;
      const message = `${product.producttitle}: ${product.productdescription} - Price: ₦${Number(product.productprice).toLocaleString()}`;
      
      switch(platform) {
        case 'Messenger':
          window.open(`https://www.messenger.com/${encodeURIComponent(window.location.href)}&quote=${encodeURIComponent(message)}&image=${encodeURIComponent(ogImage)}`);
          break;
        case 'facebook':
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}&quote=${encodeURIComponent(message)}&picture=${encodeURIComponent(ogImage)}`);
          break;
        case 'whatsapp':
          window.open(`https://wa.me/?text=${encodeURIComponent(message)} - ${window.location.href}&media=${encodeURIComponent(ogImage)}`);
          break;
        case 'twitter':
          window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}&url=${encodeURIComponent(window.location.href)}&media=${encodeURIComponent(ogImage)}`);
          break;
        default:
          console.error('Invalid platform');
      }
    } catch (error) {
      console.error(`Error sharing to ${platform}:`, error.message);
      toast.error(`Error sharing to ${platform}`);
    }
  };

  const handleCopyLinkClick = () => {
    navigator.clipboard.writeText(referralLink)
      .then(() => {
        setIsLinkCopied(true);
        toast.success('Referral link copied to clipboard!');
        setTimeout(() => setIsLinkCopied(false), 3000);
      })
      .catch((error) => {
        console.error('Error copying link:', error);
        toast.error('Error copying link');
      });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterChange = (filterOption) => {
    setFilter(filterOption);
    setDropdownOpen(false);
    setSearchTerm('');
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Filter products
  const filteredProducts = products.filter(product => {
    const matchesFilter = filter === 'All' || product.category === filter;
    const matchesSearchTerm = product.producttitle.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearchTerm;
  });

  const referralCount = user?.referredUsers?.length || 0;

  return (
    <div className="min-h-screen w-full bg-gray-50">
      <ToastContainer position="top-right" autoClose={5000} />
      
      {/* Header Section */}
      <div className="w-full p-6 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold">
            Welcome back, {user.firstName} {user.lastName}!
          </h1>
          <p className="mt-2 opacity-90">
            Here's what's happening with your account today.
          </p>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Balance Card */}
          <div className="bg-white rounded-lg shadow p-6 flex items-center">
            <div className="p-3 rounded-full bg-blue-100 text-blue-600 mr-4">
              <DollarSign className="w-6 h-6" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Account Balance</p>
              <p className="text-2xl font-semibold text-gray-900">
                ₦{user.balance ? Number(user.balance).toLocaleString() : "0.00"}
              </p>
            </div>
          </div>

          {/* Referrals Card */}
          <div className="bg-white rounded-lg shadow p-6 flex items-center">
            <div className="p-3 rounded-full bg-green-100 text-green-600 mr-4">
              <Users className="w-6 h-6" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Total Referrals</p>
              <p className="text-2xl font-semibold text-gray-900">{referralCount}</p>
              <p className="text-xs text-gray-500 mt-1">Earn more by referring friends</p>
            </div>
          </div>

          {/* Referral Link Card */}
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex justify-between items-center mb-2">
              <p className="text-sm font-medium text-gray-500">Your Referral Link</p>
              <button
                onClick={handleCopyLinkClick}
                className="text-sm flex items-center text-blue-600 hover:text-blue-800"
              >
                {isLinkCopied ? (
                  <>
                    <Check className="w-4 h-4 mr-1" /> COPIED
                  </>
                ) : (
                  <>
                    <Copy className="w-4 h-4 mr-1" /> COPY
                  </>
                )}
              </button>
            </div>
            <div className="flex items-center bg-gray-50 rounded-md p-2">
              <Share2 className="w-4 h-4 text-gray-400 mr-2" />
              <p className="text-sm text-gray-600 truncate">{referralLink}</p>
            </div>
          </div>
        </div>
      </div>

        {/* Referral Section */}
  {user.referredby && (
    <div className="bg-white p-4 mx-auto  rounded-lg shadow-md">
      <p className="text-gray-800 font-medium">
        You were referred by <span className="text-blue-600 underline">{user.referredby.firstName} {user.referredby.lastName}</span>
      </p>
      <p className="text-gray-600 mt-1">
        Referral Number: <span className="underline">{user.referredby.phoneNumber}</span>
      </p>
    </div>
  )}

      {/* Referral Email Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6 mt-10 ">
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Send Referral Via Email</h2>

          <div className="mb-4">
  <label htmlFor="referral-name" className="block text-sm font-medium text-gray-700">
    Recipient's Name
  </label>
  <input
    type="text"
    id="referral-name"
    value={nameto}
    onChange={(e) => setName(e.target.value)}
    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm p-2 border"
    placeholder="Enter recipient's name"
  />
</div>
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              placeholder="Enter recipient's email"
              value={referralEmail}
              onChange={(e) => setReferralEmail(e.target.value)}
              className="flex-grow px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <button
              onClick={handleSendReferralEmail}
              disabled={isSendingReferral}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md flex items-center justify-center min-w-[150px]"
            >
              {isSendingReferral ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Sending...
                </>
              ) : (
                <>
                  <Send className="w-4 h-4 mr-2" />
                  Send Referral
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Upload Receipt Button */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
        <button
          onClick={() => setShowModal(true)}
          className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md shadow-md transition duration-200"
        >
          Upload Payment Receipt
        </button>
      </div>

      {/* Products Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        {/* Search and Filter */}
        <div className="mb-6">
          <form className="flex flex-col sm:flex-row gap-4">
            <div className="relative flex-grow">
              <input
                type="search"
                placeholder="Search products..."
                value={searchTerm}
                onChange={handleSearchChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div className="relative">
              <button
                id="dropdown-button"
                onClick={toggleDropdown}
                className="w-full sm:w-auto flex items-center justify-between bg-white text-gray-700 border border-gray-300 px-4 py-2 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                type="button"
              >
                {filter}
                <svg
                  className="w-5 h-5 ml-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 1l4 4 4-4"
                  />
                </svg>
              </button>
              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                  <ul className="py-1">
                    <li>
                      <button
                        onClick={() => handleFilterChange('All')}
                        className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                        type="button"
                      >
                        All
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </form>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProducts.map((product) => (
            <div key={product._id} className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-[1.02]">
              {/* Product Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={product.productimage}
                  alt={product.producttitle}
                  className="w-full h-full object-cover"
                />
                {/* Commission Badges */}
                <div className="absolute top-2 left-2 flex gap-2">
                  <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                    Direct: {product.directcommission}%
                  </span>
                  <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                    Indirect: {product.inDirectcommission}%
                  </span>
                </div>
              </div>

              {/* Product Content */}
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-1">{product.producttitle}</h3>
                <p className="text-sm text-gray-600 mb-2">{product.productlocation}</p>
                <p className="text-gray-700 mb-4 line-clamp-2">{product.productdescription}</p>
                
                {/* Price and Actions */}
                <div className="flex items-center justify-between border-t pt-3">
                  <p className="text-lg font-semibold text-blue-600">
                    ₦{Number(product.productprice).toLocaleString()}
                  </p>
                  <div className="flex gap-2">
                    <button
                      onClick={() => downloadProductForm(product.productformfile)}
                      className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5 mr-1"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M20 8.25V18c0 3-1.79 4-4 4H8c-2.21 0-4-1-4-4V8.25c0-3.25 1.79-4 4-4"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8 13h4M8 17h8"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Download
                    </button>
                  </div>
                </div>

                {/* Additional Actions */}
                <div className="mt-3 flex justify-between">
                  <button
                    onClick={() => showtransaction(product._id)}
                    className="text-sm text-blue-600 hover:text-blue-800"
                  >
                    View Transactions
                  </button>
                  <button
                    onClick={() => showProductDetails(product._id)}
                    className="text-sm text-blue-600 hover:text-blue-800"
                  >
                    Share
                  </button>
                </div>

                {/* Share Buttons */}
                <div className="mt-3 flex justify-center gap-3">
                  <FacebookMessengerShareButton
                    onClick={() => shareProduct(product, 'Messenger')}
                    quote={`${product.producttitle}: ${product.productdescription}`}
                    url={window.location.href}
                  >
                    <FacebookMessengerIcon size={28} round />
                  </FacebookMessengerShareButton>
                  <FacebookShareButton
                    onClick={() => shareProduct(product, 'facebook')}
                    quote={`${product.producttitle}: ${product.productdescription}`}
                    url={window.location.href}
                  >
                    <FacebookIcon size={28} round />
                  </FacebookShareButton>
                  <WhatsappShareButton
                    onClick={() => shareProduct(product, 'whatsapp')}
                    title={`${product.producttitle}: ${product.productdescription}`}
                    separator=" - "
                    url={window.location.href}
                  >
                    <WhatsappIcon size={28} round />
                  </WhatsappShareButton>
                  <TwitterShareButton
                    onClick={() => shareProduct(product, 'twitter')}
                    title={`${product.producttitle}: ${product.productdescription}`}
                    url={window.location.href}
                  >
                    <XIcon size={28} round />
                  </TwitterShareButton>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Product Details Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-gray-900">Product Details</h2>
                <button
                  onClick={closeProductDetails}
                  className="text-gray-400 hover:text-gray-500"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <img
                  src={products.find(p => p._id === selectedProduct)?.productimage || ''}
                  alt="Product"
                  className="w-full h-auto rounded-lg"
                />
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Attachments</label>
                  <input
                    onChange={handleFileChangeattachment}
                    className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none mb-2"
                    type="file"
                    multiple
                  /> 
    
    {/* Display selected files with remove buttons */}
                <div className="space-y-2">
                  {attachments.map((file, index) => (
                    <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded-md">
                      <div className="flex items-center truncate">
                        <svg className="w-5 h-5 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                        <span className="truncate">{file.name}</span>
                      </div>
                      <button
                        type="button"
                        onClick={() => removeAttachment(index)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  ))}
               n   </div>
                </div>
              </div>

                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
                    <input
                      type="text"
                      value={products.find(p => p._id === selectedProduct)?.producttitle || ''}
                      readOnly
                      className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Price</label>
                    <input
                      type="text"
                      value={`₦ ${Number(products.find(p => p._id === selectedProduct)?.productprice).toLocaleString()}`}
                      readOnly
                      className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
                    <input
                      type="text"
                      value={products.find(p => p._id === selectedProduct)?.productlocation || ''}
                      readOnly
                      className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Prospect's Name</label>
                    <input
                      type="text"
                      name="prospectName"
                      value={products.find(p => p._id === selectedProduct)?.prospectName || ''}
                      onChange={(e) => handleProspectChange(e, 'prospectName')}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Prospect's Email</label>
                    <input
                      type="email"
                      name="prospectEmail"
                      value={products.find(p => p._id === selectedProduct)?.prospectEmail || ''}
                      onChange={(e) => handleProspectChange(e, 'prospectEmail')}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
                    <input
                      type="tel"
                      name="mobileNumber"
                      value={products.find(p => p._id === selectedProduct)?.mobileNumber || ''}
                      onChange={(e) => handleProspectChange(e, 'mobileNumber')}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div>
              </div>

              <div className="mt-6 flex justify-end space-x-3">
                <button
                  onClick={closeProductDetails}
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  disabled={isLoading}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center"
                >
                  {isLoading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Sending...
                    </>
                  ) : (
                    'Send Details'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Transactions Modal */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-gray-900">Transactions</h2>
                <button
                  onClick={closetransactions}
                  className="text-gray-400 hover:text-gray-500"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Date of Pay
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Mobile No
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Units Sold
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Amount Paid
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Balance
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {transactions.map((transaction) => (
                      <tr key={transaction._id}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {new Date(transaction.dateOfPay).toLocaleDateString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {transaction.nameofbuyer}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {transaction.mobileNumber}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {transaction.unitsSold}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          ₦{Number(transaction.amountPaid).toLocaleString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          ₦{Number(transaction.balance).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-6 flex justify-end">
                <button
                  onClick={closetransactions}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Upload Receipt Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-gray-900">Upload Payment Receipt</h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-gray-500"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Client List Section */}
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-3">Select Client</h3>
                  <div className="border rounded-lg overflow-hidden">
                    <div className="max-h-96 overflow-y-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Select
                            </th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Name
                            </th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Email
                            </th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Phone
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {clients.map((client) => (
                            <tr key={client._id}>
                              <td className="px-4 py-2 whitespace-nowrap">
                                <input
                                  type="radio"
                                  name="selectedClient"
                                  checked={formData.clientId === client._id}
                                  onChange={() => setFormData({
                                    ...formData,
                                    clientId: client._id,
                                    clientName: `${client.firstName} ${client.lastName}`,
                                    clientEmail: client.email,
                                    clientPhone: client.phone
                                  })}
                                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                />
                              </td>
                              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                                {client.firstName} {client.lastName}
                              </td>
                              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                                {client.email}
                              </td>
                              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                                {client.phone}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Payment Details Section */}
                <div className="space-y-4">
                  <h3 className="text-lg font-medium text-gray-900">Payment Details</h3>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Receipt Image</label>
                    <input
                      onChange={handleFileChange}
                      className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
                      type="file"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Property Bought</label>
                    <input
                      name="propertyBought"
                      placeholder="Property Bought"
                      value={formData.propertyBought}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Amount Paid</label>
                    <input
                      name="propertyPrice"
                      placeholder="Amount Paid"
                      value={formData.propertyPrice}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Number of Units</label>
                    <input
                      name="noOfUnits"
                      placeholder="Number of Units"
                      value={formData.noOfUnits}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  {/* Selected Client Preview */}
                  {formData.clientId && (
                    <div className="mt-4 p-3 bg-gray-50 rounded-md">
                      <h4 className="text-sm font-medium text-gray-700 mb-1">Selected Client:</h4>
                      <p className="text-sm text-gray-600">
                        {formData.clientName} ({formData.clientEmail})
                      </p>
                    </div>
                  )}
                </div>
              </div>

              <div className="mt-6 flex justify-end space-x-3">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={handleUploadAndSendEmail}
                  disabled={isLoading || !formData.clientId}
                  className={`px-4 py-2 text-white rounded-md flex items-center ${
                    isLoading || !formData.clientId ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'
                  }`}
                >
                  {isLoading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Uploading...
                    </>
                  ) : (
                    'Upload and Send'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;